import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const projectIntegrationService = createApi({
    reducerPath: 'projectIntegrationService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['ProjectIntegration'],
    endpoints: (builder) => ({
        getAllProjects: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.projectIntegrationController.getAll}/${body.page}/${body.offset}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        saveProject: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.projectIntegrationController.save}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateProject: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.projectIntegrationController.update}/${body.payload.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteProject: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.projectIntegrationController.delete}/${body.id}${body.type ? `?type=${body.type}` : ""}`,
                    method: 'DELETE',
                    headers: {
                        Authorization: `Bearer ${body.token}`
                    },
                };
            },
        }),
        getProjectById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.projectIntegrationController.getById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        searchProject: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.projectIntegrationController.search}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        findAllProjects: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.projectIntegrationController.findAll}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
    })
});

export const {
    useGetAllProjectsMutation,
    useSaveProjectMutation,
    useUpdateProjectMutation,
    useDeleteProjectMutation,
    useGetProjectByIdMutation,
    useSearchProjectMutation,
    useFindAllProjectsMutation,
} = projectIntegrationService;
